module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-MediumItalic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-MediumItalic.eot
// module id = 18
// module chunks = 8